import { KeyboardDatePicker } from '@material-ui/pickers';
import { FormControl, FormLabel, RadioGroup } from '@material-ui/core';

import { RadioOption } from 'shared/components';

import { useShutdownTime } from './hooks';

import makeClasses from './ShutdownTime.style';

import type { ShutdownTimeOption } from 'features/menu-page/domain';

export function ShutdownTime(props: Props) {
  const { customDate, onChange, onAcceptCustomDate } = props;

  const {
    lang,
    isCustomOpt,
    openDatePicker,
    hasCustomDate,
    deadline,
    valueOption,
    handleOpenDatePicker,
    handleCloseDatePicker,
    handleAcceptCustomDate,
    handleOnChange,
  } = useShutdownTime({ customDate, onChange, onAcceptCustomDate });

  const _classes = makeClasses();

  return (
    <section aria-label='select-time'>
      <FormControl fullWidth component='fieldset'>
        <FormLabel component='legend' classes={{ root: _classes.legend }}>
          {lang.title}
        </FormLabel>
        <RadioGroup
          name='shutdown-time'
          aria-label='shutdown time'
          onChange={handleOnChange}
          classes={{ root: _classes.radioGroup }}
        >
          <RadioOption
            variant='card'
            value={valueOption.DAILY}
            title={lang.option.daily.title}
            description={lang.option.daily.description}
          />

          <RadioOption
            variant='card'
            value={valueOption.CUSTOM}
            title={lang.option.custom.title}
            description={lang.option.custom.description}
            onClick={handleOpenDatePicker}
          >
            <p
              hidden={!isCustomOpt}
              data-has-custom-date={hasCustomDate}
              className={_classes.customDateMsg}
            >
              {!hasCustomDate && lang.option.custom.hasDate.false}
              {hasCustomDate && (
                <>
                  {lang.option.custom.hasDate.true}
                  <span>{customDate.toLocaleDateString('en-CA')}</span>
                </>
              )}
            </p>
          </RadioOption>
          <KeyboardDatePicker
            disableToolbar
            disablePast
            label=''
            id='shutdown-custom-dialog'
            margin='normal'
            variant='dialog'
            format='yyyy-MM-dd'
            minDate={deadline.minDatePicker}
            maxDate={deadline.maxDatePicker}
            onFocus={null}
            onBlur={null}
            open={openDatePicker}
            onClose={handleCloseDatePicker}
            value={customDate}
            onAccept={handleAcceptCustomDate}
            onChange={() => {}}
            TextFieldComponent={() => null}
          />

          <RadioOption
            variant='card'
            value={valueOption.PERMANENT}
            title={lang.option.permanent.title}
            description={lang.option.permanent.description}
          />
        </RadioGroup>
      </FormControl>
    </section>
  );
}

interface Props {
  customDate: Date;
  onChange: (option: ShutdownTimeOption) => void;
  onAcceptCustomDate: (date: Date) => void;
}
